import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function InnovacrystaOnRentNaviMumbai() {



    const cardData = {





keyword: "Innova Crysta On Rent in Navi Mumbai",

headingDescription: "Shreesha Tours & Travels offers premium Innova Crysta On Rent in Navi Mumbai for airport transfers, corporate travel, business meetings, family vacations, wedding transportation, sightseeing tours, outstation trips, one-way travel, and round-trip journeys. Our chauffeur-driven Toyota Innova Crysta is known for its spacious seating, luxurious interiors, excellent ride comfort, and superior safety, making it an ideal choice for families, corporate groups, and long-distance travel. With experienced drivers, transparent pricing, doorstep pickup, flexible rental packages, well-maintained vehicles, and 24/7 customer support, we ensure every journey is safe, comfortable, and hassle-free.",

topPlaces: [
  {
    title: "Navi Mumbai to Pune",
    description: "Pune is one of the most preferred destinations from Navi Mumbai for corporate travel, family vacations, educational visits, and business meetings. Travelers can explore Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, Sinhagad Fort, Koregaon Park, and the city's famous cafés. The smooth expressway journey makes Pune an excellent destination for both same-day trips and weekend holidays."
  },
  {
    title: "Navi Mumbai to Shirdi",
    description: "Shirdi is among the most popular pilgrimage destinations in India and attracts millions of Sai Baba devotees every year. Visitors can experience Sai Baba Samadhi Temple, Dwarkamai, Chavadi, Gurusthan, and Lendi Baug while enjoying a peaceful spiritual journey. An Innova Crysta is an ideal choice for families and senior citizens traveling comfortably over long distances."
  },
  {
    title: "Navi Mumbai to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station famous for Venna Lake, Arthur's Seat, Mapro Garden, Elephant's Head Point, Lingmala Waterfall, and strawberry farms. Travelers enjoy pleasant weather, breathtaking viewpoints, boating, horse riding, and delicious local products. The spacious Innova Crysta ensures a relaxing mountain road trip with ample luggage space."
  },
  {
    title: "Navi Mumbai to Nashik",
    description: "Nashik is well known for Trimbakeshwar Jyotirlinga, Panchavati, Ramkund, Sula Vineyards, Pandavleni Caves, and religious tourism. The city is equally popular among pilgrims, wine enthusiasts, and corporate travelers. Renting an Innova Crysta makes group travel comfortable while offering enough space for luggage and a smooth highway experience."
  },
  {
    title: "Navi Mumbai to Goa",
    description: "Goa is India's favorite holiday destination offering beautiful beaches, Portuguese churches, water sports, beach shacks, nightlife, forts, casinos, and luxury resorts. Families, friends, and honeymoon couples prefer Innova Crysta rentals for the long-distance drive because of its premium comfort, spacious seating, and relaxing ride quality."
  },
  {
    title: "Navi Mumbai to Kolhapur",
    description: "Kolhapur is famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, Jyotiba Temple, authentic Kolhapuri cuisine, and rich Maratha heritage. Visitors can explore historical monuments, shopping markets, and cultural attractions while enjoying a comfortable road journey in a premium multi-utility vehicle."
  },
  {
    title: "Navi Mumbai to Ratnagiri",
    description: "Ratnagiri is one of Konkan's most beautiful destinations, known for Ganpatipule Temple, Ratnadurg Fort, Aare Ware Beach, Thiba Palace, Pawas Ashram, and Alphonso mango orchards. Travelers enjoy scenic coastal drives, peaceful beaches, seafood, and heritage attractions, making it a perfect family road trip destination."
  },
  {
    title: "Navi Mumbai to Lonavala",
    description: "Lonavala is a favorite weekend getaway featuring Tiger Point, Bhushi Dam, Pawna Lake, Rajmachi Fort, Lohagad Fort, Karla Caves, and Della Adventure Park. The pleasant climate, waterfalls during monsoon, and scenic mountain roads make it one of the most popular destinations for families and corporate outings."
  },
  {
    title: "Navi Mumbai to Aurangabad",
    description: "Aurangabad is internationally famous for the UNESCO World Heritage Sites of Ajanta Caves and Ellora Caves. Visitors also explore Grishneshwar Jyotirlinga, Daulatabad Fort, Bibi Ka Maqbara, and Panchakki. The destination combines history, architecture, spirituality, and cultural tourism, making it perfect for extended family tours."
  },
  {
    title: "Navi Mumbai to Saputara",
    description: "Saputara, Gujarat's only hill station, is known for Saputara Lake, Sunset Point, Step Garden, Ropeway, Artist Village, Gira Waterfalls, and beautiful green valleys. The peaceful atmosphere, cool climate, boating activities, and panoramic viewpoints make it an ideal destination for couples, families, and nature lovers seeking a refreshing getaway."
  }
],


"services": [
  {
    "name": "Innova Crysta on Rent in Navi Mumbai",
    "description": "Book Innova Crysta on Rent in Navi Mumbai for comfortable, premium, and chauffeur-driven travel. Choose luxury AC Innova Crysta rentals for airport transfers, corporate travel, family trips, weddings, sightseeing, and outstation journeys with transparent pricing."
  },
  {
    "name": "Innova Crysta Rental Navi Mumbai",
    "description": "Reserve Innova Crysta Rental Navi Mumbai with experienced chauffeurs, spacious seating, premium interiors, and reliable service for local and outstation travel."
  },
  {
    "name": "Innova Crysta Hire in Navi Mumbai",
    "description": "Choose Innova Crysta Hire in Navi Mumbai for business travel, family vacations, airport transfers, and long-distance journeys with professional drivers."
  },
  {
    "name": "Innova Crysta Car Rental Navi Mumbai",
    "description": "Book Innova Crysta Car Rental Navi Mumbai for luxury transportation with clean AC vehicles, comfortable seating, and experienced chauffeurs."
  },
  {
    "name": "Innova Crysta Taxi Service Navi Mumbai",
    "description": "Reserve Innova Crysta Taxi Service Navi Mumbai for reliable local, airport, and outstation travel with premium comfort and courteous chauffeurs."
  },
  {
    "name": "Book Innova Crysta in Navi Mumbai",
    "description": "Book Innova Crysta in Navi Mumbai online with instant confirmation, flexible pickup timings, transparent pricing, and 24x7 customer support."
  },
  {
    "name": "Innova Crysta Rental Service Navi Mumbai",
    "description": "Choose Innova Crysta Rental Service Navi Mumbai for premium chauffeur-driven transportation with spacious interiors and dependable travel service."
  },
  {
    "name": "Best Innova Crysta on Rent Navi Mumbai",
    "description": "Reserve the Best Innova Crysta on Rent Navi Mumbai for luxury travel with sanitized vehicles, professional chauffeurs, and exceptional customer service."
  },
  {
    "name": "Cheapest Innova Crysta Rental Navi Mumbai",
    "description": "Book the Cheapest Innova Crysta Rental Navi Mumbai with affordable pricing, premium comfort, experienced drivers, and reliable travel services."
  },
  {
    "name": "Innova Crysta Airport Pickup Navi Mumbai",
    "description": "Choose Innova Crysta Airport Pickup Navi Mumbai for timely airport arrivals with flight tracking, luggage assistance, and luxury chauffeur-driven transportation."
  },
  {
    "name": "Innova Crysta Airport Drop Navi Mumbai",
    "description": "Reserve Innova Crysta Airport Drop Navi Mumbai for punctual airport departures with comfortable seating, professional chauffeurs, and hassle-free travel."
  },
  {
    "name": "Innova Crysta Outstation Rental Navi Mumbai",
    "description": "Book Innova Crysta Outstation Rental Navi Mumbai for one-way and round-trip journeys with premium comfort, spacious seating, and experienced drivers."
  },
  {
    "name": "Innova Crysta for Long Trip Navi Mumbai",
    "description": "Choose Innova Crysta for Long Trip Navi Mumbai for family vacations, business travel, and long-distance tours with luxury interiors and extra luggage space."
  },
  {
    "name": "Innova Crysta on Rent in Vashi",
    "description": "Book Innova Crysta on Rent in Vashi for airport transfers, local rides, corporate travel, and outstation trips with professional chauffeurs."
  },
  {
    "name": "Innova Crysta on Rent in Nerul",
    "description": "Reserve Innova Crysta on Rent in Nerul for comfortable chauffeur-driven travel with premium vehicles and transparent pricing."
  },
  {
    "name": "Innova Crysta on Rent in Kharghar",
    "description": "Choose Innova Crysta on Rent in Kharghar for reliable family trips, airport transfers, business travel, and outstation journeys."
  },
  {
    "name": "Innova Crysta on Rent in Panvel",
    "description": "Book Innova Crysta on Rent in Panvel for luxury transportation with spacious seating, professional drivers, and premium travel comfort."
  },
  {
    "name": "AC Innova Crysta on Rent in Navi Mumbai",
    "description": "Reserve AC Innova Crysta on Rent in Navi Mumbai for premium chauffeur-driven travel with fully air-conditioned luxury vehicles, comfortable seating, and dependable service."
  }
],
"tableData": [
  ["Innova Crysta on Rent in Navi Mumbai", "Innova Crysta Rental Navi Mumbai"],
  ["Innova Crysta Hire in Navi Mumbai", "Innova Crysta Car Rental Navi Mumbai"],
  ["Innova Crysta Taxi Service Navi Mumbai", "Book Innova Crysta in Navi Mumbai"],
  ["Innova Crysta Rental Service Navi Mumbai", "Best Innova Crysta on Rent Navi Mumbai"],
  ["Cheapest Innova Crysta Rental Navi Mumbai", "Innova Crysta Airport Pickup Navi Mumbai"],
  ["Innova Crysta Airport Drop Navi Mumbai", "Innova Crysta Outstation Rental Navi Mumbai"],
  ["Innova Crysta for Long Trip Navi Mumbai", "Innova Crysta on Rent in Vashi"],
  ["Innova Crysta on Rent in Nerul", "Innova Crysta on Rent in Kharghar"],
  ["Innova Crysta on Rent in Panvel", "AC Innova Crysta on Rent in Navi Mumbai"]
],




whychoose: [
  {
    WhyChooseheading: "Premium Innova Crysta on Rent in Navi Mumbai",
    WhyChoosedescription: "Shreesha Travels offers Toyota Innova Crysta on rent in Navi Mumbai for local travel, airport transfers, corporate transportation, outstation trips, family vacations, and special occasions. Travel in comfort with a spacious premium MPV and experienced chauffeur."
  },
  {
    WhyChooseheading: "Luxury Travel for Families & Corporate Groups",
    WhyChoosedescription: "The Toyota Innova Crysta is known for its premium interiors, comfortable seating, excellent ride quality, and ample luggage space, making it an ideal choice for business executives, families, tourists, and group travellers."
  },
  {
    WhyChooseheading: "Available for Local, Airport & Outstation Travel",
    WhyChoosedescription: "Book an Innova Crysta for Navi Mumbai city travel, Mumbai Airport transfers, Navi Mumbai Airport pickups, weddings, business meetings, one-way journeys, round trips, and long-distance tours across India."
  },
  {
    WhyChooseheading: "Flexible Rental Packages",
    WhyChoosedescription: "Choose from hourly rentals, full-day bookings, airport transfer packages, one-way cabs, round trips, and multi-day rental plans designed to match your travel schedule."
  },
  {
    WhyChooseheading: "Professional Chauffeurs for Comfortable Travel",
    WhyChoosedescription: "Our trained drivers are familiar with Navi Mumbai, Mumbai, major expressways, and interstate routes, ensuring punctual pickups, safe driving, and a smooth travel experience."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Well-Maintained Vehicles",
    WhyChoosedescription: "Every Innova Crysta is regularly serviced, thoroughly cleaned, air-conditioned, and inspected before every booking to provide passengers with a premium and reliable journey."
  },
  {
    WhyChooseheading: "Ideal for Every Travel Requirement",
    WhyChoosedescription: "Our Innova Crysta rental service is suitable for airport transfers, corporate events, destination weddings, hotel transfers, family holidays, pilgrimage tours, VIP transportation, and business travel."
  },
  {
    WhyChooseheading: "Book Innova Crysta on Rent in Navi Mumbai with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking assistance, professional chauffeur service, and premium Toyota Innova Crysta rentals for local and outstation travel."
  }
]

};

const faqData = [
  {
    question: "Can I rent an Innova Crysta in Navi Mumbai for local travel?",
    answer: "Yes, Innova Crysta is available for local travel, business meetings, family outings, sightseeing, and full-day city rentals."
  },
  {
    question: "Do you provide Innova Crysta for airport transfers?",
    answer: "Yes, we offer Innova Crysta rentals for Mumbai Airport and Navi Mumbai Airport pickups and drops."
  },
  {
    question: "Can I book an Innova Crysta for outstation trips?",
    answer: "Yes, our Innova Crysta rental service is available for one-way, round-trip, and multi-day outstation journeys across Maharashtra and India."
  },
  {
    question: "Is Innova Crysta suitable for family vacations?",
    answer: "Yes, its spacious seating, premium comfort, and generous luggage capacity make it an excellent choice for family travel."
  },
  {
    question: "Can I hire an Innova Crysta for corporate travel?",
    answer: "Yes, the vehicle is widely preferred for executive travel, business meetings, conferences, client visits, and employee transportation."
  },
  {
    question: "Are professional drivers included with the rental?",
    answer: "Yes, every Innova Crysta booking includes an experienced chauffeur for safe and comfortable travel."
  },
  {
    question: "Can I book the vehicle for weddings and special occasions?",
    answer: "Yes, Innova Crysta is available for weddings, VIP guest transportation, family functions, hotel transfers, and social events."
  },
  {
    question: "How is the Innova Crysta rental fare calculated?",
    answer: "The rental fare depends on the trip type, travel distance, rental duration, selected package, tolls, parking charges, and additional travel requirements."
  },
  {
    question: "Can I rent an Innova Crysta for multiple days?",
    answer: "Yes, multi-day rental packages are available for vacations, business tours, religious trips, and customized itineraries."
  },
  {
    question: "How can I book Innova Crysta on Rent in Navi Mumbai with Shreesha Travels?",
    answer: "Simply share your pickup location, travel date, destination, passenger count, and rental requirement to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash More",
    feedback: "The Innova Crysta was exceptionally comfortable for our Navi Mumbai to Pune business trip. The chauffeur was professional, the vehicle was spotless, and the entire journey was smooth.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Kamat",
    feedback: "We hired an Innova Crysta for a family vacation, and the experience was outstanding. Everyone travelled comfortably, the luggage fit easily, and the service was punctual and well-organized.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta On Rent in Navi Mumbai",
  "image": "https://www.shreeshatravels.com/assets/images/innova-crysta-on-rent-in-navi-mumbai.webp",
  "description":
    "Book Innova Crysta On Rent in Navi Mumbai with Shreesha Tours & Travels for premium and comfortable taxi services. We provide Toyota Innova Crysta cabs with experienced drivers for local travel, airport transfers, outstation trips, family vacations, corporate travel, sightseeing tours, and long-distance journeys with 24x7 booking.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/innova-crysta-on-rent-in-navi-mumbai"
  }
};








    return (
        <div>
<Helmet>
  <title>Innova Crysta On Rent in Navi Mumbai | Luxury Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Innova Crysta On Rent in Navi Mumbai with Shreesha Travels for safe and comfortable luxury taxi services. Hire Toyota Innova Crysta with experienced drivers for local travel, airport transfers, outstation trips, family tours, corporate travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Innova Crysta On Rent in Navi Mumbai, Innova Crysta Rental Navi Mumbai, Innova Crysta Hire in Navi Mumbai, Innova Crysta Car Rental Navi Mumbai, Innova Crysta Taxi Service Navi Mumbai, Book Innova Crysta in Navi Mumbai, Innova Crysta Rental Service Navi Mumbai, Innova Crysta Cab Navi Mumbai, Toyota Innova Crysta Booking Navi Mumbai, Luxury Cab Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/96.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default InnovacrystaOnRentNaviMumbai;